/**
 * Created by BlueFocus5 on 2016-11-07.
 */


export default class BFSingleProject
{
   project = {};
   scope = this;

  doCopyLayers = false;
  copyOfViewToApply = [];
  layersToCopy = [];

  constructor(){

    this.bindEvents();

  }

  bindEvents() {

    let scope = this;
    $(document).ready(function () {


      function isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
      };
        if (isMobileDevice()) {
          $('body').addClass('mobi');
        }

        if ($('#bf-project-site').length > 0) {

          scope.loadProjectConfigAndClient(bf_config.prodID);

        }
      }
    )


    function creatorAreaContainerResize() {
      var val = $('.bf-tools-area').height() - 10;
      $('.creator-area-container > .center-div').css('min-height', val + 'px');
      if ($(window).width() <= 1024) {
        $('.creator-area-container > div').css('min-height', '0px');
      }
    }

    $(window).on('SingleProject-loaded', function () {
      creatorAreaContainerResize();
    })

    $(window).on('resize bodyresize', function () {
      creatorAreaContainerResize();
    })

    $(window).on('WorkArea-layer-removed WorkArea-layer-added', function () {
      scope.updateViewsLayers();
      $(window).trigger('SingleProject-addLayerFromWorkArea');
    })

    $(window).on('WorkArea-page-ready', function () {
      $(window).off('StartFilter');

      if (scope.doCopyLayers !== undefined && scope.doCopyLayers === true) {

        //$(window).trigger('ShowLoader','s2');
        scope.layersToCopy.reverse();

        var layerCounter = scope.layersToCopy.length - 1;
        $(window).trigger('ShowLoader','s2');
        

        $(window).off('FinishFilter');

        $(window).on('FinishFilter',function(){
          setTimeout(function(){
            $(window).trigger('HideLoader','s2_filter - on FinshFilter');
          },500);
        });
        $(window).off('StartFilter');
        $(window).on('StartFilter',function(){
         $(window).trigger('ShowLoader','s2_filter - on StartFilter');

        });

          $(window).off('SingleProject-addLayerFromWorkArea');
          $(window).on('SingleProject-addLayerFromWorkArea',function(){
            setTimeout(function () {
              layerCounter--;


              if ( layerCounter > -1 )
              {
                loadLayer();
              }
              else{
                
                $(window).trigger('HideLoader','s1');
                $(window).trigger('HideLoader','s1');
              }

            }, 1000);
          });



          function loadLayer(){

            $(window).trigger('Layers-addLayerToCanvas', scope.layersToCopy[layerCounter]);

          }

          loadLayer();
      }
      else
      {
        $(window).off('StartFilter');
        $(window).on('StartFilter',function(){
          $(window).trigger('ShowLoader','s2_filter - on StartFilter');

        });
        $(window).off('FinishFilter');
        $(window).on('FinishFilter',function(){
          setTimeout(function(){

            $(window).trigger('HideLoader','s2_filter - on FinshFilter');
          },500);
        });

      }

    });


  $(window).on('SingleProject-view-internal',function(e,selectedView){


    for ( var i in selectedView.images )
    {
      var mask = selectedView.images[i];

      var conf = new Object();
      conf.noselectable = false;
      conf.index = 1000;
      conf.name = mask.type;
      conf.type = mask.type;

      conf.path = mask.url;
      //conf.path05 = mask

      switch(mask.type) {
        case "print":
          conf.id = "print_mask";
          scope.workArea.addMaskPrint(conf);
          break;
        case "preview":
          conf.id = "preview_mask";
          scope.workArea.addMaskPreview(conf);
          break;
        case "design":
          conf.id = "layout_mask";
          for ( var j in selectedView.images )
          {
            if (  selectedView.images[j].type == 'design_s05' )
            {
              conf.path_s05 = selectedView.images[j].url;
            }
            if (  selectedView.images[j].type == 'design_s025' )
            {
              conf.path_s025 = selectedView.images[j].url;
            }
          }
          scope.workArea.addMaskLayout(conf);

          break;
        default:
        // nothing
      }
    }

    $(window).trigger('SingleProject-setViews',scope.currentViewId);

    })
  }


  calculatePrice(price, dealerGroupId){
    if ( dealerGroupId && ["EKUSD","HUSD"].includes(dealerGroupId) )
    {
      return parseFloat(price * 1.25).toFixed(2);
    }
    return price;
  }

  bfCreateBuy(dataJson){

    if ( bf_config.mode == 'phantom' ) return;


    if ( session.getIsDealer() )
    {
      for ( var j in dataJson.groupPrices ) {
        if (dataJson.groupPrices[j].groupId == session.getDealerGroupId()) {
          dataJson.price = this.calculatePrice(dataJson.groupPrices[j].price, session.getDealerGroupId());
          dataJson.dealerGroupId = session.getDealerGroupId()
        }
      }
    }
    else {
      if ( bf_config.shopLang === 'en' || bf_config.shopLang === 'us') {
        for (var j in dataJson.groupPrices) {
          if (dataJson.groupPrices[j].groupId === 'EK') {
            dataJson.price = this.calculatePrice(dataJson.groupPrices[j].price, "EKUSD");
          }
        }

        for (var j in dataJson.groupPrices) {
          if (dataJson.groupPrices[j].groupId === 'EKUSD') {
            dataJson.price = this.calculatePrice(dataJson.groupPrices[j].price, "EKUSD");
          }
        }

      } else {
        for (var j in dataJson.groupPrices) {
          if (dataJson.groupPrices[j].groupId === 'EK') {
            dataJson.price = dataJson.groupPrices[j].price;
          }
        }
      }
    }


    /*
     var source = $("#bf-basket-template").html();
     var template = Handlebars.compile(source);
     $('.js-bf-basket').html(template(dataJson));
     */
//console.log('trigger',dataJson);
    $(window).trigger('BASKET-data',dataJson);

  }

  loadProjectConfigAndClient(idProject) {
    var scope = this;

    session.getSessionFromShop().then(function(sts){
      if ( sts == null ) return;

      bf_config.clientID = sts.getSessionId();

      if ( bf_config.designeID != null )
      {
        $.ajax({
          // cache: false,
          headers: {
            'x-client-id': bf_config.clientID
          },
          url:  bf_config.api + 'design/'+bf_config.designeID,
          dataType: "json",
          method : "get",
          success: function (data) {

            scope.init(data);
            scope.loadClientProject(data.data);
          },
          error: function (data) {
            //  console.log(data);
          }
        });
        return;
      }

      $.ajax({
        // cache: false,
        headers: {
          'x-client-id': bf_config.clientID
        },
        url:  bf_config.api + 'product/'+idProject,
        dataType: "json",
        method : "get",
        success: function (data) {

          scope.init(data);

          $.ajax({
            // cache: false,
            headers: {
              'x-client-id': bf_config.clientID
            },
            url:  bf_config.api + 'product/'+ idProject + '/current-design',
            dataType: "json",
            method : "get",
            success: function (data) {

              bf_config.designeID = data.id;
              scope.loadClientProject(data.data);

            },
            error: function (data) {
              //  console.log(data);
            }
          });
        },
        error: function (data) {
          //  console.log(data);
        }
      });
    });
  };

  getName(){
    var scope = this;
    return scope.project.name;
  }


  getPrice(){
    var scope = this;
    if ( session.getIsDealer() )
    {
      for ( var j in scope.project.groupPrices ) {
        if (scope.project.groupPrices[j].groupId == session.getDealerGroupId()) {
          scope.project.price = scope.project.groupPrices[j].price;
        }
      }
    }
    else {
      for ( var j in scope.project.groupPrices ) {
        if (scope.project.groupPrices[j].groupId == 'EK') {
          scope.project.price = scope.project.groupPrices[j].price;
        }
      }
    }
    return scope.project.price;
  }

  scale(scale)
  {
    this.workArea.scaleTest(scale);
  }

  removeMaskLayoutTest()
  {
    this.workArea.removeMaskLayout();
  }

  toPNG()
  {
    this.workArea.toPNG();
  }


  /*
   this method get height&width from mask images and add it directly to view(side)
   */
  madeDataMoreFriendly() {
    var scope = this;

    var views = scope.prepareViews();

    /* remove no active views */
    for ( var i  in views )
    {
      if ( views[i].active == false )
      {
        views[i] = {};
        delete views[i];
      }
    }

    for ( var i  in views )
    {
      for ( var j in views[i].images ) {

        if (views[i].images[j].type == 'design') {
          views[i].width = views[i].images[j].width;
          views[i].height = views[i].images[j].height;
        }
      }
      for ( var j in views[i].images )
      {
        if (views[i].images[j].type == 'print' )
        {
          views[i].offsetHeight = ( views[i].height - views[i].images[j].height ) / 2;
          views[i].offsetWidth =  ( views[i].width - views[i].images[j].width ) / 2;
        }
      }
      if ( bf_config.mode == 'phantom' && bf_config.modePrintGenerate == true ){ //&& bf_config.modePrintGenerate == true
        for ( var j in views[i].images ) {

          if (views[i].images[j].type == 'print') {
            views[i].width = views[i].images[j].width;
            views[i].height = views[i].images[j].height;
          }
        }
      }

    }
  }


  getCurrentViewId()
  {
    return this.currentViewId;
  }

  getAllViews()
  {

    return this.prepareViews();


  }

  getCurrentView()
  {

    let views = this.prepareViews();

    for ( let i  in views )
    {
      if ( views[i].id == this.currentViewId )
      {
        return views[i];
      }
    }
  }


  updateViewsLayers(){
    var scope = this;
    var view = scope.getCurrentView();
    if ( view.data == undefined )
    {
      view.data = new Object();
    }
    view.data.layers = scope.workArea.getLayers()
  };


  haveViewsLayers(){
    var scope = this;
    var views = scope.prepareViews();

    for ( var i  in views )
    {
      if (  views[i].data == undefined || views[i].data.layers.length < 1 )
      {
        return false;
      }
    }
    return true;
  }


  prepareViews()
  {
    var scope = this;

    var views = scope.project.views;

    // todo: is it nessesery? - remove it
    if ( scope.project.views == undefined )
    {
      views =  scope.project.product.views;
    }

    return views;
  }


  getViewsIDS()
  {
    var scope = this;
    var table = [];

    var views = scope.prepareViews();

    for ( var i in views )
    {
      if ( views[i].active == true )
      {
        table.push(views[i].id);
      }
    }
    return table;
  }


  showAskAboutCopyLayers(){

    var dfd = jQuery.Deferred();


    $(window).trigger('SingleProject-CopyLayersMessage-show');


    $(window).on('CopyLayersMessage-SingleProject-copy-no',function(){

      dfd.resolve(false);
    })


    $(window).on('CopyLayersMessage-SingleProject-copy-yes',function(){

      dfd.resolve(true);
    })

    return dfd.promise();
  }



  showViews(id,isFromChange)
  {
    var scope = this;



    var views = scope.prepareViews();

    if ( id == undefined || id == null )
    {
      id = views[0].id;
    }


    var copyCurrentView =  {};
    var currentViewSize = {};

    /* save old view data to local data */

    for ( var i  in views )
    {

      if ( views[i].id === scope.currentViewId && views[i].id !== undefined )
      {

        views[i].data = scope.workArea.canvasToJson();
        currentViewSize.width = views[i].width;
        currentViewSize.height = views[i].height;

        copyCurrentView = _.clone(views[i].data);
        //console.log('copyCurrentView',copyCurrentView);
      }
    }


    /* save old view data to local data */

    scope.currentViewId = id;


    var selectedView = null;
    for ( var i  in views )
    {
      if ( views[i].id == id )
      {
        selectedView = views[i];
      }
    }


    scope.workArea.init($('#creator-area-container'), selectedView,selectedView.id);

    /* normaly it should be in HERE! */

    /* normaly it should be in HERE! */






    scope.doCopyLayers = false;
    if ( isFromChange )
    {

      if ( copyCurrentView.layers.length > 0 && ( selectedView.data == undefined || selectedView.data.layers.length < 1 ) ){

        this.showAskAboutCopyLayers().then(function(val){
          "use strict";

          $(window).trigger('WorkArea-loadingImagesStart');
          if ( val )
          {
            scope.doCopyLayers = true;
            scope.loadClientProjectCurrentView(copyCurrentView,currentViewSize);
            setTimeout(function(){
              //console.log('SingleProject-view-internal A');
              $(window).trigger('SingleProject-view-internal',selectedView);
            },500)


          }
          else
          {
            scope.loadClientProjectCurrentView();
            setTimeout(function(){
              //console.log('SingleProject-view-internal B');
              $(window).trigger('SingleProject-view-internal',selectedView);
            },500)
          }
        })
      }
      else
      {
        $(window).trigger('WorkArea-loadingImagesStart');
        scope.loadClientProjectCurrentView();
        setTimeout(function(){
          //console.log('SingleProject-view-internal C');
          $(window).trigger('SingleProject-view-internal',selectedView);
        },500)
      }

    }
    else
    {

      scope.loadClientProjectCurrentView();
      //console.log('SingleProject-view-internal D');
      $(window).trigger('SingleProject-view-internal',selectedView);
    }


    /* --->>normaly it should be in HERE! */

  }



  prepareViewsToFront()
  {
    var scope = this;

    var viewsFront = [];

    var views = scope.prepareViews();

    for ( var i in views )
    {
      if ( views[i].active )
      {
        //scope.project.views[i].workArea = new WorkArea();

        var obj = new Object();
        obj.id = views[i].id;
        obj.name = views[i].name;
        viewsFront.push(obj);

      }
    }
    var sendingObj = new Object();
    sendingObj.views = viewsFront;

    scope.viewsSimple = viewsFront;

    $(window).trigger('SingleProject-prepareViews',sendingObj);

  }


  getPrices()
  {
    return this.project.groupPrices;
  }


  getPricesFlorianStrcuture()
  {
    var scope = this;
    var prices_florian = new Object();
    var prices =  scope.getPrices();

    for ( var i in prices )
    {
      prices_florian[prices[i].groupId] = prices[i].price;
    }

    return prices_florian;
  }


  init(json)
  {
    var scope = this;

    scope.project = json;

    if ( json.product != undefined )
    {
      scope.project = json.product;
    }

    if ( scope.project.wideMode )
    {
      $(window).trigger('SingleProject-WideMode-on');
    }
    else
    {
      $(window).trigger('SingleProject-WideMode-off');
    }

    scope.workArea = new WorkArea();
    scope.workArea.binds();

    scope.madeDataMoreFriendly();

    scope.prepareViewsToFront();



    this.bfCreateBuy(scope.project);


    $(window).on('Tools-changeView',function(e,id){


      scope.showViews(id,true);

    });

    $(window).on('SingleProject-loaded',function(e,id){

      if ( bf_config.mode != 'phantom' )
      {
        scope.showViews();
      }

    });

  }


  getClonedWorkArea()
  {
    return _.clone(scope.workArea.canvasToJson());
  }


  saveProject()
  {
    var scope = this;

    var views = scope.prepareViews();

    for ( var i in scope.viewsSimple )
    {
      //scope.viewsSimple[i] =
      for ( var j in views ){
        if ( scope.viewsSimple[i].id == views[j].id )
        {
          if ( scope.getCurrentViewId() == scope.viewsSimple[i].id )
          {
            scope.viewsSimple[i].data = _.clone(scope.workArea.canvasToJson());
          }
          else
          {
            scope.viewsSimple[i].data = views[j].data;
          }
        }
      }
    }

    //var id = 1;

    var dfd = jQuery.Deferred();

    $.ajax({
      // cache: false,
      headers: {
        'x-client-id': bf_config.clientID
      },
      //url:  bf_config.api + 'product/'+ idProduct +'/design',
      //url:  bf_config.api + 'design/'+ idProduct +'/in-cart',
      url:  bf_config.api + 'design/'+ bf_config.designeID,
      dataType: "json",
      data : JSON.stringify(scope.viewsSimple),
      method : "post",
      success: function(data)
      {
        dfd.resolve(data);

      },
      error:function(data)
      {
        // console.log(data);
        dfd.resolve(data);
      }
    });

    return dfd.promise();
  }


  loadClientProject(data)
  {
    var scope = this;


    //var load = scope.workArea.canvasElementsFromJson(data);
    if ( data == undefined || data == "" )
    {
      $(window).trigger('SingleProject-loaded');
      return;
    }

    var data = $.parseJSON(data);

    var views = scope.prepareViews();

    for ( var i in views )
    {
      for ( var j in data )
      {
        if ( views[i].id == data[j].id )
        {
          views[i].data = data[j].data;
        }
      }
    }

    // scope.loadClientProjectCurrentView();
    $(window).trigger('SingleProject-loaded');

  }


  loadClientProjectCurrentView(copyOfViewToApply,currentViewSize) {
    var scope = this;

    var views = scope.prepareViews();
    let copyOneToOne = false;

    scope.layersToCopy = [];
    for (var i in views) {
      if (views[i].id == scope.getCurrentViewId() && views[i].id != undefined ) {

        if (scope.copyOfViewToApply !== undefined && scope.doCopyLayers === true) {

          if ( views[i].width == currentViewSize.width && views[i].height == currentViewSize.height ){
            // the same view size, copy one to one
            copyOneToOne = true;
          }

          var layerCounter = 0;
          for ( var j in copyOfViewToApply.layers )
          {
            layerCounter++;
            //todo: move this to one function with CutCopyClone function

            var idLayer =  copyOfViewToApply.layers[j].idLayer;
            var layer =  cloneDeep(bfLayers.getLayerById(idLayer));
            if ( copyOneToOne ) {
              layer.isCopy = true;
            }
            else
            {
              layer.isCopy = false;
            }

            var filters = [];

            var filtersCurrent = layer.instance.filters;
            for ( var i in filtersCurrent )
            {
              var filter = filtersCurrent[i];
              for ( var j in filter )
              {
                if ( (typeof filter[j]) === 'number' )
                {
                  var obj = {};
                  obj['type'] = j;
                  obj[j] = filter[j];
                  filters.push(obj);
                }
              }
            }

            if ( layer.filters == undefined )
            {
              layer.filters = [];
            }
            _.assign(layer.filters,filters);
            if ( layer )
            {
              layer.id = layer.idLayer = new Date().getTime()+layerCounter;
              layer.instance.idLayer = layer.id;
              //layer.instance = this.currentLayer.instance;
              if ( layer.font != undefined )
              {
                layer.type = 'text';
              }

              //$.extend(layer,bfLayers.getLayerById(idLayer));
              //  layer.instance = layer.instance.toJSON();
              var lClone =  cloneDeep(layer);

              scope.layersToCopy.push( lClone );
            }

          }

        }

        scope.workArea.canvasElementsFromJson(views[i]);

      }
    }
  }


  getActiveLayer()
  {
    return this.workArea._findElementByActiveCanvasObject();
  }


  setCropImgValuesOnActiveElement(val)
  {
    return this.workArea.setCropImgValuesOnActiveElement(val);
  }

  logWorkarea()
  {
    this.workArea.logScope();
  }

}








